export default __webpack_public_path__ + "static/media/thumb5.99287875.png";